<template>
  <el-dialog
    :visible.sync="visible"
    :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="35%"
  >
    <div class="handle-content">
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="rules"
        class="demo-form-inline"
      >
        <el-form-item label="故障分析" :label-width="'90px'" prop="action">
          <el-select
            v-model="dataForm.action"
            placeholder="请选择"
            :style="{ width: '315px' }"
          >
            <el-option label="确认故障" :value="1"></el-option>
            <el-option label="无故障" :value="2"></el-option>
            <el-option label="无法确认转技术" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="处理"
          v-if="dataForm.action === 2"
          :label-width="'90px'"
          prop="suggest"
        >
          <el-select
            v-model="dataForm.suggest"
            placeholder="请选择"
            :style="{ width: '315px' }"
          >
            <el-option label="持续观察，完结" :value="1"></el-option>
            <el-option label="系统报错，完结" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="处理"
          v-if="dataForm.action === 1 && ompStatus === 99"
          :label-width="'90px'"
          prop="suggest"
        >
          <el-select
            v-model="dataForm.suggest"
            placeholder="请选择"
            :style="{ width: '315px' }"
          >
            <el-option label="持续观察，完结" :value="1"></el-option>
            <el-option label="发送回调工单" :value="2"></el-option>
            <el-option label="流转" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="处理"
          v-if="dataForm.action === 1 && ompStatus !== 99"
          :label-width="'90px'"
          prop="suggest"
        >
          <el-select
            v-model="dataForm.suggest"
            placeholder="请选择"
            :style="{ width: '315px' }"
          >
            <el-option label="持续观察，完结" :value="1"></el-option>
            <el-option label="流转" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="紧急程度"
          v-if="dataForm.action === 1 && dataForm.suggest === 4"
          :label-width="'90px'"
          prop="suggest"
        >
          <el-select
            v-model="dataForm.emergency"
            placeholder="请选择"
            :style="{ width: '315px' }"
          >
            <el-option label="一般" :value="0"></el-option>
            <el-option label="紧急" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="人员选择"
          v-if="
            dataForm.action === 3 ||
            dataForm.suggest === 2 ||
            dataForm.suggest === 4
          "
          :label-width="'90px'"
          prop="nextPerson"
        >
          <el-select
            v-model="dataForm.nextPerson"
            placeholder="请选择"
            filterable
            :style="{ width: '315px' }"
          >
            <el-option
              v-for="(item, index) in persons"
              :key="index"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题类型" :label-width="'90px'" prop="tagType">
          <el-select
            v-model="dataForm.tagType"
            placeholder="问题类型"
            size="small"
            class="area-form-item"
            :style="{ width: '315px' }"
            @change="changeHandle"
          >
            <el-option
              v-for="(item, index) in readyData.questionTypeList"
              :key="index"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="问题子类" :label-width="'90px'" prop="childTagArr">
          <el-select
            v-model="dataForm.childTagArr"
            placeholder="问题子类"
            size="small"
            class="area-form-item"
            :style="{ width: '315px' }"
            multiple
            @change="subChange"
          >
            <el-option
              v-for="(item, index) in subList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" :label-width="'90px'" prop="remark">
          <el-input
            type="textarea"
            placeholder="说明"
            v-model="dataForm.remark"
            :style="{ width: '315px' }"
          />
        </el-form-item>
      </el-form>
    </div>
    <template slot="footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="dataFormSubmitHandle()"
        >确认</el-button
      >
      <el-button @click="visible = false">取消</el-button>
    </template>
  </el-dialog>
</template>
<script>
import axios from "@/utils/axios";
export default {
  data() {
    return {
      title: null,
      loading: false,
      ompStatus: null,
      dataForm: {
        cloudId: null,
        action: null,
        sn: null,
        nextPerson: null,
        suggest: null,
        remark: null,
        organId: null,
        userId: null,
        tagType: null,
        childTag: null,
        childTagArr: [],
        emergency: null,
      },
      visible: false,
      persons: null,
      readyData: {},
      subList: [],
    };
  },
  computed: {
    rules() {
      return {
        action: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        suggest: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        nextPerson: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        emergency: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
      };
    },
  },
  methods: {
    //初始化
    init() {
      this.visible = true;
      this.dataForm.organId = localStorage.getItem("organId");
      this.dataForm.userId = localStorage.getItem("userId");
      console.log(this.ompStatus);
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.getPersonList();
        this.getSourceList();
        this.getOmpStatus();
      });
    },
    getOmpStatus() {
      axios
        .post(`/api/cloudControl/snStatus`, { id: this.dataForm.sn })
        .then((res) => {
          this.ompStatus = res;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //获取故障处理人列表
    getPersonList() {
      axios
        .post("/api/cloudControl/persons", { id: this.dataForm.organId })
        .then((rs) => {
          this.persons = rs;
        });
    },
    //获取来源列表
    getSourceList() {
      axios
        .post(`/api/customerServiceCenter/ready`, { id: this.dataForm.organId })
        .then((res) => {
          this.readyData = res;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    changeHandle(value) {
      axios
        .post(`/api/customerServiceCenter/getChild`, { id: value })
        .then((res) => {
          this.subList = res;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    subChange(value) {
      this.dataForm.childTag = value.join(",");
    },
    dataFormSubmitHandle() {
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        axios
          .post(`/api/cloudControl/dealFault`, this.dataForm)
          .then((res) => {
            if (res) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
              this.loading = false;
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message({
              message: err,
              type: "error",
              duration: 500,
              onClose: () => {
                this.visible = false;
                this.$emit("refreshDataList");
              },
            });
          });
      });
    },
  },
};
</script>